import * as types from './constants';

// Update Lookbook Order Fulfillment
export const updateLookbookOrderFulfillmentRequest = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST, payload: data }
);

export const updateLookbookOrderFulfillmentDone = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_DONE, payload: data }
);

export const updateLookbookOrderFulfillmentFailed = errors => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_FAILED, payload: errors }
);

export const updateLookbookOrderFulfillmentClearErrors = prop => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_CLEAR_ERRORS, payload: prop }
);

export const updateLookbookOrderFulfillmentReset = () => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_RESET }
);
